export default __webpack_public_path__ + "static/media/banners_gmm_enero800_330x330.2995850b.jpg";